import { render, staticRenderFns } from "./Recibo.vue?vue&type=template&id=1cfd61b6&scoped=true&lang=pug&"
import script from "./Recibo.vue?vue&type=script&lang=js&"
export * from "./Recibo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfd61b6",
  null
  
)

export default component.exports